import React, { useEffect, useRef } from "react";
import { clearAllBodyScrollLocks, disableBodyScroll } from "body-scroll-lock";
import Flickity from "flickity";
import "flickity-imagesloaded";
import { BlockIcon } from './icons';
import ModalUpsellProductDetailsGallery from "./ModalUpsellProductDetailsGallery";
import ModalUpsellProductInfo from "./ModalUpsellProductInfo";


function ModalUpsellProductDetails({ product, setLayoutActive }) {
  if (!product) {
    return
  }

  const slideGalleryMain = useRef();
  const slideGalleryThumb = useRef();
  let flickMain = useRef();
  let flickThumb = useRef();

  const handleBack = () => {
    setLayoutActive("product");
  };

  let initialX = null
  let initialY = null
  const contentDetails = document.querySelector('.modal-upsell__product-details')

  useEffect(() => {
    if (!slideGalleryMain.current) {
      return
    }

    flickMain = new Flickity(slideGalleryMain.current, {
      draggable: ">1",
      freeScroll: false,
      prevNextButtons: false,
      autoPlay: false,
      pageDots: true,
      imagesLoaded: true,
      setGallerySize: true,
      watchCSS: true,
      cellAlign: "center",
      cellSelector: ".product-detail__media",
    });

    slideGalleryMain.current?.addEventListener('touchstart', (e) => {
      initialX = e.touches[0].clientX
      initialY = e.touches[0].clientY
    })

    slideGalleryMain.current?.addEventListener('touchmove', (e) => {
      if (initialX == null || initialY == null) {
        return
      }
      const currentX = e.touches[0].clientX
      const currentY = e.touches[0].clientY
      const diffX = initialX - currentX
      const diffY = initialY - currentY

      if (Math.abs(diffX) > Math.abs(diffY)) {
        clearAllBodyScrollLocks()
        document.body.overflow = 'hidden'
      }
    })

    slideGalleryMain.current?.addEventListener('touchend', () => {
      document.body.overflow = 'auto'
      contentDetails && disableBodyScroll(contentDetails)
    })

    if (!slideGalleryThumb.current) {
      return
    }

    flickThumb = new Flickity(slideGalleryThumb.current, {
      prevNextButtons: false,
      draggable: false,
      percentPosition: false,
      groupCells: true,
      cellAlign: "left",
      pageDots: false,
      asNavFor: slideGalleryMain.current,
    });
  }, [slideGalleryMain, slideGalleryThumb, product.id]);

  return (
    <>
      <div className="product-detail__header">
        <div className="product-detail__back" onClick={handleBack}>
          <BlockIcon icon={"goback"} />
          <span>Go back</span>
        </div>
      </div>
      <div className="product-detail__main">
        <ModalUpsellProductInfo product={product} className={"product-detail__info--mobile"} />
        <div className="product-detail__gallery">
          <div className="product-detail__thumbnail">
            <div className="product__thumbnails" ref={slideGalleryThumb}>
              <ModalUpsellProductDetailsGallery product={product} />
            </div>
          </div>
          <div className="product-detail__medias" ref={slideGalleryMain}>
            <ModalUpsellProductDetailsGallery product={product} />
          </div>
        </div>
        <div className="product-detail__content">
          <ModalUpsellProductInfo product={product} className={"product-detail__info--desktop"} />
          <div
            className="product-detail__description"
            dangerouslySetInnerHTML={{ __html: product.description }}
          ></div>
        </div>
      </div>
    </>
  );
}


export default ModalUpsellProductDetails;